import { SearchX } from "lucide-react";

import { ErrorPage } from "./ErrorPage";

export function NotFoundPage() {
  return (
    <ErrorPage
      code="404"
      title="Page not found"
      description="The page you requested does not exist, may have moved, or is no longer available."
      icon={SearchX}
    />
  );
}
